import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueLocalCobranca, TLocalCobranca } from "../../types/api/financeiro/pesquisar-locais-cobranca";

export default function SelectLocaisCobranca({
    value,
    onChange,
    required = false,
    error = false,
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.codigo ?? ''}${value.nome ? ` - ${value.nome}` : ''}` : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Local de cobrança`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        title="Selecionar local de cobrança"
                        queryPath="/financeiro/configuracoes/pesquisar-locais-cobranca"
                        getItemKey={(item) => item.codigo}
                        defaultValue={value || defValueLocalCobranca}
                        getItemLabel={(item) => `${item.codigo} - ${item.nome}`}
                        onChange={(value) => {
                            onChange(value as TLocalCobranca)
                            handleClose()
                        }}
                    />
                </Dialog>
            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TLocalCobranca | null
    onChange: (arg: TLocalCobranca | null) => void
    required?: boolean
    error?: boolean
}